// 题库
import request from '@/router/axios';

let urlPrefix = '/api/exam/etfield';

/**
 * 新增题库
 * @param {Object} data 题库对象
 * @param {String} data.fieldName 题库名称
 * @param {String} data.code 题库编号
 * @param {String} data.memo 题库描述
 */
export const addEtfield = data => {
    return request(urlPrefix, { data }, 'post');
};

/**
 * 批量删除题库
 * @param {Array} data 题库fieldId列表
 */
export const removeEtfield = data => {
    return request(`${urlPrefix}/deleteBatch`, { data }, 'delete');
};

/**
 * 编辑题库
 * @param {Object} data 题库对象
 * @param {String} data.fieldId 题库id
 * @param {String} data.fieldName 题库名称
 * @param {String} data.code 题库编号
 * @param {String} data.memo 题库描述
 */
export const updateEtfield = data => {
    return request(urlPrefix, { data }, 'put');
};

/**
 * 根据题库etfield获取题库详情
 * @param {String} etfield 题库etfield
 */
export const getEtfieldDetail = etfield => {
    return request(`${urlPrefix}/${etfield}`);
};

/**
 * 获取所有题库列表
 */
export const getAllEtfield = () => {
    return request(`${urlPrefix}/all`);
};

/**
 * 分页查询题库列表
 * @param {Number} page 当前页码
 * @param {Number} limit 每页条目数
 * @param {Object} params 其他参数
 */
export const getEtfieldList = (page, limit, params = {}) => {
    return request(`${urlPrefix}/query`, {
        params: {
            ...params,
            page,
            limit
        }
    });
};